import { render, staticRenderFns } from "./Triptych.vue?vue&type=template&id=7ad7582b&"
import script from "./Triptych.vue?vue&type=script&lang=js&"
export * from "./Triptych.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports